import { specialtyIdToPlaceOfServiceMap } from '../../consts/specialtyMapping';

export const isSpecialtyRequiresPlaceOfService = (specialtyId: string): boolean =>
  !!specialtyIdToPlaceOfServiceMap[specialtyId];
